import React, { Component } from "react";
import { DKIcon, DKButton, DKIcons, DKLine, showToast, TOAST_TYPE } from "deskera-ui-library";
import Incrementor from "../../common/Incrementor";
import ApiManager from "../../../managers/ApiManager";
import { PAGE_ELEMENT } from "../ComponentList";
import sanitizeSVG from '@mattkrick/sanitize-svg';
import { stringSanitizer } from "../../../managers/common/CommonUtil";

/*
PROPS
- data // this is current components data
- onDataChange
- className
*/

class CollectionSectionEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div
        className={
          "column parent-width border-box mt-m border-radius-s p-r border-m shadow-s " +
          this.props.className
        }
      >
        {this.getAllItems(this.componentData.value)}
        <div className="row-reverse ">
          <DKButton
            title="+ Add new item"
            onClick={this.addItem}
            className="bg-app text-white "
          />
        </div>

        <DKLine style={{ height: 3 }} className="mt-xl mb-xl" />

        <Incrementor
          className=""
          title="Icon size"
          value={this.componentData.style.iconSize}
          onChange={(value) => {
            this.changeStyle("iconSize", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Icon spacing"
          value={this.componentData.style.cellSpacing}
          onChange={(value) => {
            this.changeStyle("cellSpacing", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Icon corners"
          value={this.componentData.style.iconRadius}
          onChange={(value) => {
            this.changeStyle("iconRadius", value);
          }}
        />

        <DKLine style={{ height: 3 }} className="mt-xl mb-xl" />

        <div className=" row">
          <Incrementor
            title="Header"
            value={this.componentData.style.titleSize}
            onChange={(value) => {
              this.changeStyle("titleSize", value);
            }}
          />
          <div>
            <input
              type="color"
              className="ml-r"
              value={this.componentData.style.titleColor}
              onChange={(e) => this.changeStyle("titleColor", e.target.value)}
            />
          </div>
        </div>
        {this.props.data.type !== PAGE_ELEMENT.ICON && (
          <div className="mt-s row mb-l">
            <Incrementor
              className="mt-l parent-width"
              title="Description"
              value={this.componentData.style.descriptionSize}
              onChange={(value) => {
                this.changeStyle("descriptionSize", value);
              }}
            />
            <div className="mt-l">
              <input
                type="color"
                className="ml-r"
                value={this.componentData.style.descriptionColor}
                onChange={(e) =>
                  this.changeStyle("descriptionColor", e.target.value)
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  getAllItems(items) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getItemRow(item, index));
    });
    return arr;
  }
  getItemRow(item, index) {
    return (
      <div className="row mb-l">
        <div className="position-relative">
          <DKIcon
            src={item.icon}
            className="mr-s ic-l  unselectable border-m shadow-s"
            style={{ maxWidth: 50 }}
          />
          <div
            className="position-absolute cursor-hand"
            style={{ top: 0, left: 0, width: 50, height: 50 }}
          >
            <input
              className=" cursor-hand "
              style={{ width: "100%", height: "100%", opacity: 0 }}
              type="file"
              accept="image/*"
              onChange={(e) => {
                this.uploadImageToAWS(e.target.files[0], index);
              }}
            />
          </div>
        </div>
        <div className="column  ml-xs parent-width ">
          <div className="row">
            <input
              className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m "
              type="text"
              value={item.title}
              onChange={(e) => this.changeValue("title", e.target.value, index)}
              placeholder="Title"
              onBlur={(e) => this.focusOutValue("title", e.target.value, index)}
            />
            <DKButton
              className="bg-gray1 border-m ml-r"
              icon={DKIcons.ic_delete}
              onClick={() => this.deleteItem(index)}
            />
          </div>
          {this.props.data.type !== PAGE_ELEMENT.ICON && (
            <input
              className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m mt-s"
              type="text"
              value={item.description}
              onChange={(e) =>
                this.changeValue("description", e.target.value, index)
              }
              placeholder="Description"
              onBlur={(e) => this.focusOutValue("description", e.target.value, index)}
            />
          )}
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  addItem = () => {
    let value = this.componentData.value;
    if (value.length > 0) {
      value.push({ ...value[value.length - 1] });
    } else {
      value.push({
        title: "<b>Title</b>",
        description: "Description",
        icon: "https://i.ibb.co/h93Ztf7/image-8.png",
      });
    }
    this.componentData.value = value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////

  deleteItem = (index) => {
    let value = this.componentData.value;
    value.splice(index, 1);
    this.componentData.value = value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  changeValue = (property, value, index) => {
    let new_value = this.componentData.value;
    new_value[index][property] = value;
    this.componentData.value = new_value;
    this.props.onDataChange(this.componentData);
  };

  focusOutValue = (property, value, index) => {
    const sanitizedValue = stringSanitizer(value);
    let new_value = this.componentData.value;
    new_value[index][property] = sanitizedValue;
    this.componentData.value = new_value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  async uploadImageToAWS(imageData, index) {
    const cleanImage = await sanitizeSVG(imageData)
    if (!cleanImage) {
        showToast("Image upload failed,seems like a malicious file. Please try uploading another image.", TOAST_TYPE.FAILURE);
        return;
    }
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.changeValue("icon", url, index);
      },
      (err) => {
        alert("Upload failed");
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default CollectionSectionEditor;
